export const regexpPhone =
  /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?(?!-)[\d\- ]{7,10}$/;

export const regexpSumm = /^(?!0\d)(?:\d{1,11}(?:\.\d{1,2})?|100000000000)$/;

/* Виды ИНН */
export const regexpInnOrganisation = /^[0-9]{10,10}$/;
export const regexpInnUser = /^[0-9]{12,12}$/;
export const regexpInn = /^[0-9]{10,12}$/;

export const regexpInnIndividual = /^[0-9]{12}$/;

export const regexpSnils = /^[0-9]{11}$/;

export const regexpLetter = /^[A-Za-zА-Яа-яЁё\- ]+$/;

export const regexpNumberLot = /^(?:[1-9][0-9]{0,2})$/;

export const regexPhoneNumber = /^\+7\d{3}\d{3}\d{2}\d{2}$/;

export const regexOnlyNumber = /\D/g;
